import PropTypes from "prop-types"
import styled from "styled-components"
import { fontRegular } from "../../utils/fontFamily"

const FlexDiv = styled.div`
  display: flex;
  align-items: ${(props) => props.alignItems};
  justify-content: ${(props) => props.justifyContent};
  flex-direction: ${(props) => props.fxLayout};
  flex-wrap: ${(props) => props.fxWrap};
  gap: ${(props) => props.fxGap};
`

FlexDiv.propTypes = {
  alignItems: PropTypes.string,
  justifyContent: PropTypes.string,
  fxLayout: PropTypes.string,
  fxWrap: PropTypes.string,
  fxGap: PropTypes.string,
}

FlexDiv.defaultProps = {
  alignItems: "flex-start",
  justifyContent: "flex-start",
  fxLayout: "row",
  fxWrap: "wrap",
  fxGap: "0",
}

export default FlexDiv
